import React, { Fragment } from 'react';

class Zoom extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {

    const selectedValue = event.target.value;

    if (this.props.onChange) {
      this.props.onChange({ level: selectedValue });
    }
  }

  render() {

    const selected = this.props.selected;

    return (
      <div className={this.props.className}>
        {this.props.allowDay && (<Fragment>
          <input
            id="zoomday"
            type="radio"
            name="zoom"
            value="Day"
            onChange={this.handleChange}
            checked={selected === "Day"} />
          <label htmlFor="zoomday">Day</label>
        </Fragment>)}
        {this.props.allowWeek && (<Fragment>
          <input
            id="zoomweek"
            type="radio"
            name="zoom"
            value="Week"
            onChange={this.handleChange}
            checked={selected === "Week"} />
          <label htmlFor="zoomweek">Week</label>
        </Fragment>)}
        {this.props.allowMonth && (<Fragment>
          <input
            id="zoommonth"
            type="radio"
            name="zoom"
            value="Month"
            onChange={this.handleChange}
            checked={selected == "Month"} />
          <label htmlFor="zoommonth">Month</label>
        </Fragment>)}
      </div>
    );
  }
}

Zoom.defaultProps = {
  allowDay: true,
  allowWeek: true,
  allowMonth: false,
  selectedView: "week",
  className: "zoom-bar"
};

export default Zoom;



// WEBPACK FOOTER //
// ./src/components/calendar/Zoom.js